const types = {
    SET_LIST_GROUP: '[JACKPOT] SET LIST GROUP',
    SET_LIST_JACKPOT: '[JACKPOT] SET LIST JACKPOT',
    SET_VIEW_JACKPOT: '[JACKPOT] SET VIEW JACKPOT',
    SET_LIST_GROUP_JACKPOT: '[JACKPOT] SET LIST GROUP JACKPOT'
}

export {
    types,
}